import { createContext } from 'react'
import type {
    SignInCredential,
    SignUpCredential,
    SignInQrcodeCredential,
    SignInotpCredential,
    AuthResult,
    User,
    OauthSignInCallbackPayload,
    SignotpCredential,
    empcodevaild,
    changepasswordsumbit,
    
} from '@/@types/auth'

type Auth = {
    authenticated: boolean
    user: User
    signIn: (values: SignInCredential) => AuthResult
    signInWithKeycloak: (accessToken: string) => AuthResult
    signInotp: (values: SignInotpCredential) => AuthResult
    signUp: (values: SignUpCredential) => AuthResult
    signotp: (values: SignotpCredential) => AuthResult
    signIn1: (values: SignInQrcodeCredential) => AuthResult
empcodevaild: (values: empcodevaild) => AuthResult

changepasswordsumbit:(values: changepasswordsumbit) => AuthResult


    signOut: () => void
    oAuthSignIn: (
        callback: (payload: OauthSignInCallbackPayload) => void,
    ) => void
}

const defaultFunctionPlaceHolder = async (): AuthResult => {
    await new Promise((resolve) => setTimeout(resolve, 0))
    return {
        status: '',
        message: '',
    }
}

const defaultOAuthSignInPlaceHolder = (
    callback: (payload: OauthSignInCallbackPayload) => void,
): void => {
    callback({
        onSignIn: () => {},
        redirect: () => {},
    })
}

const AuthContext = createContext<Auth>({
    authenticated: false,
    user: {},
    signIn: async () => defaultFunctionPlaceHolder(),
    signInWithKeycloak: async () => defaultFunctionPlaceHolder(),
    signInotp: async () => defaultFunctionPlaceHolder(),
    signotp: async () => defaultFunctionPlaceHolder(),
    signUp: async () => defaultFunctionPlaceHolder(),
    empcodevaild: async () => defaultFunctionPlaceHolder(),
    changepasswordsumbit : async () => defaultFunctionPlaceHolder(),
    signIn1: async () => defaultFunctionPlaceHolder(),
    signOut: () => {},
    oAuthSignIn: defaultOAuthSignInPlaceHolder,
})

export default AuthContext
